import {
  Bitmap,
  Container,
  delayedCall,
  detectDeviceEnvironmentConstants,
  dispatcher,
  IEvent,
  ingenuity,
  IObject,
  killDelayedCall,
  Linear,
  SpineBase,
} from "@quest/base-core";
import { BaseGameViewGame } from "./BaseGameViewGame";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotEventConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class FreeSpinBarController {
  // Base game view
  private view: BaseGameViewGame;

  //  progress bar spine elements
  private fsActiveHeadContainer: Container;
  private fsActiveHeadContainer2:Container;
  private freeSpinesActiveContainer: Container;

  // Progress bar string constants
  private FSACTIVEBASECONTAINER_: string = "fsActiveBaseContainer_";
  private FSACTIVEBASESPINE_: string = "fsActiveBaseSpine_";
  private FSACTIVEGEM_: string = "fsActiveGemimage_";
  private FSACTIVENUMBER_: string = "fsActiveNumber_";

  // Delay constants
  private FREE_SPIN_TRIGGER_SCREEN_DELAY: string = "freeSpinTriggerScreenDelay";
  private fsDelayTimer: number = 500;
  // private fsDelayTimer: number = 2000;

  // class variables
  private cascadeCount: number;
  private totalCascade: number;
  private lastCascade: boolean = false;
  private sequenceCounter: number = 0;
  private animationArray: any[] = [];

  /**
   * Constrcutor method to initialize events and UI elements.
   * @param baseGameView
   */
  constructor(baseGameView: BaseGameViewGame) {
    this.view = baseGameView;
    this.initializeComponent();
    this.subscribeEvents();
  }

  /**
   * Class method to subscribe events.
   */
  private subscribeEvents(): void {
    dispatcher.on(eventDispatchers.ON_CASCADE_UPDATE_FS_BAR, this.onCascade, this);
    dispatcher.on(eventDispatchers.ON_CASCADE_COMPLETE_UPDATE_FS_BAR, this.onCascadeComplete, this);
    dispatcher.on(eventDispatchers.SHOW_FS_BAR_WIN, this.showFreeSpinAward, this);
    dispatcher.on(eventDispatchers.RESET_FS_BAR, this.resetElements, this);
  }

  /**
   * class method to initialize UI components.
   */
  private initializeComponent(): void {
    this.fsActiveHeadContainer = this.view.getContainerByID("fsActiveHeadContainer");
    this.freeSpinesActiveContainer = this.view.getContainerByID("freeSpinesActiveContainer");
  if(!ingenuity.deviceEnv.isDesktop) {
       this.fsActiveHeadContainer2 = this.view.getContainerByID('fsActiveHeadContainer2');
    }
  }
  /**
   * Class method to start progress bar animations during cascade.
   * @param evt
   */
  private onCascade(evt: IEvent): void {
    this.cascadeCount = evt.data;
    this.freeSpinesActiveContainer.visible = true;
    this.cascadeCount <= 3 ? this.playGemEffectAnim() : this.playFreeSpinAwardEffectAnim();
    this.showNonGlowImage();
    this.playSound();
  }
 private playFSWinSound(): void {
        const soundObj: IObject = { id: SoundConstantGame.FREE_SPIN_WIN, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD };
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
    }
  
   private playSound(): void {
        let soundKey: string = SoundConstantGame.FREE_SPIN_PROGRESS_1;
        switch (this.cascadeCount) {
            case 1:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_1;
                break;
            case 2:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_2;
                break;
            case 3:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_3;
                break;
            case 4:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_4;
                break;
            case 5:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_5;
                break;
            case 6:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_6;
                break;
            case 7:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_7;
                break;
        }
        const soundObj: IObject = { id: soundKey, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD };
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
    }


  /**
   * Class method to initiate free spin award animation sequence after free spin awarded.
   * @param evt
   */
  private onCascadeComplete(evt: IEvent): void {
    this.totalCascade = evt.data;
    if (this.totalCascade > 3) {
      this.sequenceCounter = 1;
    //  this.showFreeSpinAward();
    } else {
      this.fsDelayTimer = 500;
    }
    this.showNextPresentationCallDelay();
  }

  /**
   *  Method to show free spin award animations.
   */
  private showFreeSpinAward(): void {
    this.playFSWinSound();
    this.addAnimOnTop();
    this.cascadeCount > 3 && this.playWinAnim();
  }

  /**
   * Method to show next animation during free spin award.
   */
  private showNextFSAnim(): void {
    this.sequenceCounter += 1;
    if (this.sequenceCounter === this.totalCascade || this.sequenceCounter === gameConstants.MAX_PROGRESS_COUNT) {
      this.lastCascade = true;
      this.playAwardGlowAnim();
    }
   this.showFreeSpinAward();
  }

  private showGemImages():void{
    for(let i = 1;i < this.cascadeCount;i++){
      let image = this.view.getImageById(`${this.FSACTIVEGEM_+i}`) ;
      let spine = this.view.getSpineById(`${this.FSACTIVEBASESPINE_+i}`)
      image.visible = true;
      spine.visible = false;
    }
  }
  private hideGemImages():void{
    for(let i = 1;i < 7;i++){
      let image = this.view.getImageById(`${this.FSACTIVEGEM_+i}`) ;
      let spine = this.view.getSpineById(`${this.FSACTIVEBASESPINE_+i}`)
      image && (image.visible = false);
      spine && (spine.visible = false);
    }
  }
  /**
   * Method to play free spin cascade win animation.
   */
  private playWinAnim(): void {
    let gemEffectAnim: any;
    if(this.lastCascade){
      const animationId: string = `${this.FSACTIVEBASESPINE_ + this.sequenceCounter}`;
      gemEffectAnim = this.view.getSpineById(animationId);
      this.animationArray.push(gemEffectAnim);
      gemEffectAnim.state.clearTracks();
      gemEffectAnim.onComplete.dispose();
      gemEffectAnim.visible = true;
      gemEffectAnim.playAnim("big_gem_loop_effect_in", false);
      this.showGemImages();
    } else {
      let activeImage = this.view.getImageById(`fsActiveBaseimage_${this.sequenceCounter}`);
      let gemImage = this.view.getImageById(`${this.FSACTIVEGEM_+this.sequenceCounter}`);
      activeImage.visible = true;
      gemImage.visible = false;
      activeImage.alpha = 0
      gemEffectAnim = ingenuity.currentGame.add.tween(activeImage).to({ alpha: 1 }, gameConstants.TIMER_250, Linear.None, true, 0, 0, false);
    }
    if (this.lastCascade) {
      this.fsDelayTimer = 0;
      this.showNextPresentationCallDelay();
    } else {
      gemEffectAnim.onComplete.addOnce(() => {
        if(!this.lastCascade){
            gemEffectAnim.stop();
            ingenuity.currentGame.tweens.remove(gemEffectAnim);
        } else {
        gemEffectAnim.state.clearTracks();
        gemEffectAnim.onComplete.dispose();
        }
        this.showNextFSAnim();
      }, this);
    }
  }

  /**
   * Method to play free spin award glow animation.
   */
  private playAwardGlowAnim(): void {
    const freespinsActive:Container = this.view.getContainerByID('fsActiveHeadContainer')
    const animationId: string = `${this.FSACTIVEBASESPINE_ + this.cascadeCount}`;
    const animationName: string = "big_gem_loop_effect_in";
    const fsNumberGlowAnim: SpineBase = this.view.getSpineById(animationId);
    fsNumberGlowAnim.alpha = 1;
    fsNumberGlowAnim.visible = true;
    freespinsActive.visible = true;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
    const freespinsActive2:Container = this.view.getContainerByID('fsActiveHeadContainer2')
    freespinsActive2.visible = true;
    }
    freespinsActive.visible = true;
    this.animationArray.push(fsNumberGlowAnim);
    fsNumberGlowAnim.playAnim(animationName, false);
  }

  /**
   * Method to add UI element to top of the view to correct indexing of UI.
   */
  private addAnimOnTop(): void {
    const animParentContainer: Container = this.view.getContainerByID(`${this.FSACTIVEBASECONTAINER_ + this.sequenceCounter}`);
    this.freeSpinesActiveContainer.addChild(animParentContainer);
  }

  /**
   * Method to play gem effect animation during cascade animation.
   */
  private playGemEffectAnim(): void {
    const gemEffectAnim: SpineBase = this.view.getSpineById(`${this.FSACTIVEBASESPINE_ + this.cascadeCount}`);
    const fsActiveBaseContainer: Container = this.view.getContainerByID(`${this.FSACTIVEBASECONTAINER_ + this.cascadeCount}`);
    fsActiveBaseContainer.visible = true;
    gemEffectAnim.visible = true;
    gemEffectAnim.playAnim("small_gem_effect", false);
    this.animationArray.push(fsActiveBaseContainer);
    this.animationArray.push(gemEffectAnim);
  }

  private showNonGlowImage():void{
     if(this.cascadeCount > 1){
      this.view.getImageById(`fsActiveBaseimage_${this.cascadeCount - 1}`).visible = false;
      this.view.getSpineById(`${this.FSACTIVEBASESPINE_}${this.cascadeCount - 1}`).visible = false;
      this.view.getImageById(`${this.FSACTIVEGEM_}${this.cascadeCount - 1}`).visible = true;
    }
  }


  /**
   * Method to play  free spin award head effect animation
   */
  private playFreeSpinAwardEffectAnim(): void {
    this.playNumberEffectAnim();
    this.showFsNumber();
    //this.playHitNumberAnim();
  }

  /**
   * Method to activate and play animation on awarded number of free spin.
   */
  private playNumberEffectAnim(): void {
    const gemEffectAnim: SpineBase = this.view.getSpineById(`${this.FSACTIVEBASESPINE_ + this.cascadeCount}`);
    const fsActiveBaseContainer: Container = this.view.getContainerByID(`${this.FSACTIVEBASECONTAINER_ + this.cascadeCount}`);
    fsActiveBaseContainer.visible = true;
    gemEffectAnim.visible = true;
    gemEffectAnim.playAnim("big_gem_effect", false);
    this.animationArray.push(fsActiveBaseContainer);
    this.animationArray.push(gemEffectAnim);
  }

  /**
   * Method to show active Free Spin number on progress bar.
   */
  private showFsNumber(): void {
    const fsNumber: Bitmap = this.view.getImageById(`${this.FSACTIVENUMBER_ + this.cascadeCount}`);
    fsNumber.visible = true;
    this.animationArray.push(fsNumber);
  }

  /**
   * Method to reset UI elements indexing after animations played.
   */
  private resetAnimationHierarchy(): void {
    for (let i: number = 1; i <= 7; i++) {
      const animParentContainer: Container = this.view.getContainerByID(`${this.FSACTIVEBASECONTAINER_ + i}`);
      this.freeSpinesActiveContainer.addChild(animParentContainer);
    }
  }

  /**
   * Method to call next win presentation with delay after free spin progress bar animation completed.
   */
  private showNextPresentationCallDelay(): void {
    delayedCall(
      this.FREE_SPIN_TRIGGER_SCREEN_DELAY,
      this.fsDelayTimer,
      () => {
        killDelayedCall(this.FREE_SPIN_TRIGGER_SCREEN_DELAY);
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      },
      this
    );
  }

  /**
   * Method to reset UI elemetns and variables states.
   */
  private resetElements(): void {
    this.fsActiveHeadContainer.visible = false;
    if(!ingenuity.deviceEnv.isDesktop) {
      this.fsActiveHeadContainer2.visible = false;  
    }
    this.sequenceCounter = 0;
    this.lastCascade = false;
    this.animationArray.forEach((anim: any) => {
      anim.visible = false;
    }, this);
    this.resetAnimationHierarchy();
    this.hideGemImages()
  }
}
